import { Job } from 'generated/apolloComponents'
import useTranslation from 'next-translate/useTranslation'
import CheckProcess from '../atoms/CheckProcess'
import ListCheck from '../atoms/ListCheck'
import Accordion from '../molecules/Accordion'
import BenefitsList from '../molecules/BenefitsList'
import {
  getTools,
  getWorkFlow,
  getWorkFlowManage,
  isEmpty,
} from '@/helpers/utils'

interface IProps {
  job: Job
}

const JobDescription = ({ job }: IProps) => {
  const { t } = useTranslation()

  const descriptionLabel = () => {
    if (
      (!job.offer || job.offer.length === 0) &&
      (!job.requirements || job.requirements.length === 0)
    ) {
      return t('jobs:description')
    }
    return t('jobs:details')
  }
  return (
    <>
      {job.details && job.details.length > 0 && (
        <div className='bg-white rounded-lg px-6 md:px-10 py-6 md:py-10 mb-4 '>
          <Accordion id={1} title={descriptionLabel()} expanded>
            <div
              className='content list--check mt-6 -mb-6'
              dangerouslySetInnerHTML={{
                __html: job.details,
              }}
            />
          </Accordion>
        </div>
      )}

      {job.offer && job.offer.length > 0 && (
        <div className='bg-white rounded-lg px-6 md:px-10 py-6 md:py-10 mb-4 '>
          <Accordion id={2} title={t('jobs:offer')} expanded>
            <div
              className='content list--check mt-6 -mb-6'
              dangerouslySetInnerHTML={{ __html: job.offer }}
            />
          </Accordion>
        </div>
      )}

      {job.requirements && job.requirements.length > 0 && (
        <div className='bg-white rounded-lg px-6 md:px-10 py-6 md:py-10 mb-4 '>
          <Accordion id={3} title={t('jobs:requirements')} expanded>
            <div
              className='content list--check mt-6 -mb-6'
              dangerouslySetInnerHTML={{ __html: job.requirements }}
            />
          </Accordion>
        </div>
      )}

      {(!isEmpty(getWorkFlow(job)) || !isEmpty(getTools(job))) && (
        <div className='bg-white rounded-lg px-6 md:px-10 py-6 md:py-10 mb-4 '>
          <Accordion id={4} title={t('common:how_we_work')}>
            <>
              {(() => {
                const flow: any = getWorkFlow(job)
                const howWeFlow: any = getWorkFlowManage(job)
                const tools: any = getTools(job)
                return (
                  <div className='w-full mt-6 -mb-4'>
                    <div className='w-full'>
                      {flow.how_we_code && flow.how_we_code.length !== 0 && (
                        <ListCheck
                          data={flow.how_we_code}
                          langKey='code'
                          className='font-normal'
                          color={job.company.themeColor}
                        />
                      )}
                      {flow.how_we_test && flow.how_we_test.length !== 0 && (
                        <ListCheck
                          data={flow.how_we_test}
                          langKey='test'
                          className='font-normal '
                          color={job.company.themeColor}
                        />
                      )}
                    </div>
                    <div className='w-full'>
                      {tools && tools.length !== 0 && (
                        <ListCheck
                          data={tools}
                          langKey='tools'
                          className='font-normal'
                          color={job.company.themeColor}
                        />
                      )}
                      {howWeFlow.how_we_manage &&
                        howWeFlow.how_we_manage.length !== 0 && (
                          <ListCheck
                            data={howWeFlow.how_we_manage}
                            langKey='hwm'
                            className='font-normal'
                            color={job.company.themeColor}
                          />
                        )}
                    </div>
                  </div>
                )
              })()}
            </>
          </Accordion>
        </div>
      )}

      {job.benefits && job.benefits.length !== 0 && (
        <div className='bg-white rounded-xl px-6 md:px-10 py-6 md:py-10 my-4'>
          <Accordion id={5} title={t('common:benefits')}>
            <div className='xl:flex w-full flex-wrap mt-4'>
              <BenefitsList
                title={t('company:packages_and_funding')}
                color={
                  job.company.themeColor ? job.company.themeColor : '#726EFF'
                }
                type='benefits'
                benefits={job.benefits}
                categories={['package', 'training', 'medical', 'financial']}
                className='xl:w-1/3 md:w-1/2'
              />
              <BenefitsList
                color={
                  job.company.themeColor ? job.company.themeColor : '#726EFF'
                }
                title={t('company:relocation_package')}
                type='relocation'
                benefits={job.benefits}
                categories={['relocation']}
                className='xl:w-1/3 md:w-1/2'
              />
              <BenefitsList
                color={
                  job.company.themeColor ? job.company.themeColor : '#726EFF'
                }
                title={t('company:amenities')}
                type='perks'
                benefits={job.benefits}
                categories={['kitchen', 'other', 'parking']}
                className='xl:w-1/3 md:w-1/2'
              />
            </div>
          </Accordion>
        </div>
      )}

      {job.recruitmentProcess && job.recruitmentProcess.length > 0 && (
        <div className='bg-white rounded-lg px-6 md:px-10 py-6 md:py-10 mb-4 '>
          <Accordion id={6} title={t('common:recruitment_process')}>
            <>
              {(() => (
                <div className=''>
                  <CheckProcess
                    data={job.recruitmentProcess}
                    className='font-normal'
                    color={job.company.themeColor ?? '#726EFF'}
                  />
                </div>
              ))()}
            </>
          </Accordion>
        </div>
      )}
    </>
  )
}

export default JobDescription
